import { render, staticRenderFns } from "./LikedModal.vue?vue&type=template&id=39a13239&scoped=true"
import script from "./LikedModal.vue?vue&type=script&lang=js"
export * from "./LikedModal.vue?vue&type=script&lang=js"
import style0 from "./LikedModal.vue?vue&type=style&index=0&id=39a13239&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a13239",
  null
  
)

export default component.exports